import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "authentication" }

import AuthenticationDialogTest from "@/components/AuthenticationDialogTest.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthenticationViewTest',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "authentication__title" }, [
      _createElementVNode("h1", null, "Планета Вита")
    ], -1)),
    _createVNode(AuthenticationDialogTest),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "authentication__end" }, null, -1))
  ]))
}
}

})